import { environment } from 'src/environments/environment';

export const intercomSettings = {
  app_id: environment.intercomAppId,
  hide_default_launcher: true,
  custom_launcher_selector: '#my-custom-intercom-button'
};
